module.exports = __webpack_public_path__ + "img/icon-industry.966f85bb.svg";